"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_1 = require("react");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const sharedUtils_1 = require("src/utils/sharedUtils");
const reduxHooks_1 = require("src/hooks/reduxHooks");
const Saver_1 = __importDefault(require("src/components/organisms/Saver"));
const AppNavHeader_1 = __importDefault(require("src/components/organisms/AppNavHeader"));
const AppFormGroup_1 = __importDefault(require("src/components/molecules/AppFormGroup"));
const ControlledToggle_1 = __importDefault(require("src/components/molecules/ControlledToggle"));
const selectors_1 = require("src/stores/applicationStore/auth/selectors");
const selectors_2 = require("src/stores/exportedStore/auth/selectors");
const thunk_1 = require("src/stores/applicationStore/projects/thunk");
const ProjectSettings_module_css_1 = __importDefault(require("./styles/ProjectSettings.module.css"));
const ProjectSettings = () => {
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const [errors, setErrors] = (0, react_1.useState)(undefined);
    const project = (0, reduxHooks_1.useAppSelector)(selectors_2.selectCurrentProject);
    const me = (0, reduxHooks_1.useAppSelector)(selectors_1.selectUser);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const setDefaultValues = (buildFrom) => {
        return {
            name: (buildFrom === null || buildFrom === void 0 ? void 0 : buildFrom.name) || "",
            user_auth_sign_required: (buildFrom === null || buildFrom === void 0 ? void 0 : buildFrom.user_auth_sign_required) || false,
        };
    };
    const form = (0, react_hook_form_1.useForm)({
        defaultValues: setDefaultValues(project),
        shouldUnregister: true,
    });
    const canEdit = (0, react_1.useMemo)(() => (0, sharedUtils_1.access)({ profile: me, section: "projects", permission: "edit" }), [me]);
    const onSubmit = (data) => {
        dispatch((0, thunk_1.editProjectThunk)({
            data,
            projectID: project.id,
            setIsSuccess: setIsSuccess,
            setIsLoading: setIsLoading,
            setErrors: setErrors,
        }));
    };
    (0, react_1.useEffect)(() => {
        form.reset(setDefaultValues(project));
    }, [project === null || project === void 0 ? void 0 : project.id]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: ProjectSettings_module_css_1.default.container }, { children: [(0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: i18n_1.default.t("general settings") }), (0, jsx_runtime_1.jsxs)(Saver_1.default, Object.assign({ controlClassName: ProjectSettings_module_css_1.default.saverControl, btnProps: { isLoading: isLoading, showSuccess: isSuccess }, onSubmit: form.handleSubmit(onSubmit), canSave: canEdit }, { children: [(0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { error: errors === null || errors === void 0 ? void 0 : errors.name, type: "text", label: i18n_1.default.t("Name"), register: form.register, registerName: "name" }), (0, jsx_runtime_1.jsx)(ControlledToggle_1.default, { name: "user_auth_sign_required", control: form.control, label: i18n_1.default.t("Mandatory signature for user identification"), hint: i18n_1.default.t("When calling the identify method, the USER_HASH parameter for USER_ID will be required") })] }))] })));
};
exports.default = ProjectSettings;
